import { Grid, Paper, Typography } from '@mui/material';
import CardDTO from '@src/adapters/dto/card/CardDTO';

import { CardNoteType } from '@src/constants/CardNoteType';
import { NoteItem } from './NoteItem';
import { useMemo } from 'react';

interface Params {
  card: CardDTO;
}

export function NotesTab({ card }: Params) {
  const scrubNotes = useMemo(
    () => card.notes.filter((n) => n.type === CardNoteType.Scrub),
    [card.notes]
  );

  const generalNotes = useMemo(
    () => card.notes.filter((n) => n.type === CardNoteType.General),
    [card.notes]
  );
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Paper>
          <Typography
            variant="h6"
            sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
            Scrub Notes
          </Typography>

          {scrubNotes.map((note) => (
            <NoteItem key={note.id} card={card} note={note} />
          ))}
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper>
          <Typography
            variant="h6"
            sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
            General Notes
          </Typography>

          {generalNotes.map((note) => (
            <NoteItem key={note.id} card={card} note={note} />
          ))}
        </Paper>
      </Grid>
    </Grid>
  );
}
